module.exports = __webpack_public_path__ + "img/l.a7917e65.webp";